import { createMuiTheme } from "@material-ui/core/styles";

export default createMuiTheme({
  palette: {
    primary: {
      main: "#663399"
    },
    secondary: {
      main: "#6902bf"
    },
    type: "light",
    text: {
      primary: "#101012",
      secondary: "#545456"
    },
    error: {
      main: "#d32f2f"
    },
    success: {
      main: "#28a745"
    }
  }
});
